





































































import {
  Component,
  ProvideReactive,
  Mixins,
} from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import TabbedDynamicForm from '@/components/FormBuilder/TabbedDynamicForm.vue';
import TextFieldFactory from '@/classes/field-components/TextFieldFactory';
import { FieldComponent } from '@/types/FieldComponent';
import { PimcoreEntityLayout } from '@/types/entity';
import UserMixin from '@/mixins/UserMixin';
import PimcoreIntrospectionMixin from '@/mixins/PimcoreIntrospectionMixin';
import FieldCollectionFactory from '@/classes/field-components/FieldCollectionFactory';
import AbstractFieldComponentFactory from '@/classes/field-components/AbstractFieldComponentFactory';
import { CrudOperation } from '@/types/CrudOperation';
import FieldCollectionNormalizer, { NormalizedFieldCollection } from '@/classes/normalizers/field-normalizers/FieldCollectionNormalizer';
import { differenceWith, isEqual } from 'lodash';

@Component({
  components: {
    TabbedDynamicForm,
  },
})
export default class SupplierProfile extends Mixins(UserMixin, PimcoreIntrospectionMixin) {
  fieldComponents: FieldComponent[] = [];

  entityName = 'Supplier';

  textFieldFactory!: TextFieldFactory;

  componentFactory!: AbstractFieldComponentFactory;

  normalizer!: FieldCollectionNormalizer;

  loading = false;

  editing = false;

  file = null;

  anyFieldEdited = false;

  @Getter('layoutByType', { namespace: 'entity' })
  layoutByType!: (entity: string, type: string) => PimcoreEntityLayout | null;

  @Action('fetchEntityLayouts', { namespace: 'entity' })
  fetchEntityLayouts: any;

  @Action('sendEditedInfo', { namespace: 'profile' })
  sendEditedInfo!: Function;

  @ProvideReactive()
  get operation() {
    return this.editing ? CrudOperation.update : CrudOperation.read;
  }

  get submitButtonLabel() {
    return this.anyFieldEdited ? 'Отправить запрос на редактирование' : 'Запрос на редактирование';
  }

  get fields() {
    return this?.pimcoreEntityIntrospection?.mutationFields || [];
  }

  async created() {
    this.createNormalizer();
    this.createComponentFactory();
  }

  async beforeMount() {
    await this.initPimcoreIntrospection(this.entityName);
    if (this.pimcoreEntityIntrospection) this.createFieldComponents();
    await this.fetchEntityLayouts('Supplier');
  }

  createNormalizer() {
    this.normalizer = new FieldCollectionNormalizer();
  }

  createComponentFactory() {
    const scalarFactories = [
      new TextFieldFactory(),
    ];
    const factories = [
      new FieldCollectionFactory(new AbstractFieldComponentFactory(scalarFactories)),
      ...scalarFactories,
    ];
    this.componentFactory = new AbstractFieldComponentFactory(factories);
  }

  async createFieldComponents() {
    this.fieldComponents = await this.componentFactory.createComponentsFromFields(this.fields, this.supplierData);
  }

  async onSubmit(formData: Record<string, any> = {}) {
    if (!this.anyFieldEdited && !this.file) return;
    this.loading = true;
    try {
      await this.prepareDataAndSendEditInfo(formData);
    } finally {
      this.loading = false;
    }
  }

  async prepareDataAndSendEditInfo(formData: Record<string, any>) {
    const { contacts, ...otherFields } = formData;
    const editedFields = this.processFormDataForEditInfo(otherFields);
    const processedContacts = this.processContacts(contacts);

    const result = await this.sendEditedInfo({
      name: this.supplierData.legal_name,
      editedFields,
      contacts: processedContacts,
      file: this.file,
    });

    if (result) {
      this.editing = false;
    }
  }

  processFormDataForEditInfo(formData = {}) {
    return Object
      .entries(formData)
      .map(([key, value]) => {
        const translatedKey = this.$t(key).toString();
        const prevValue = this.supplierData[key];
        const requestEditObj = {
          [translatedKey]: {
            prevValue,
            value,
          },
        };

        return requestEditObj;
      });
  }

  processContacts(contacts: NormalizedFieldCollection) {
    if (!contacts) return [];
    const reverseNormalizedContacts = this.normalizer.reverseNormalize(contacts);
    const diffContacts = differenceWith(reverseNormalizedContacts, this.supplierData.contacts, isEqual);

    const contactsWithTranslatedKeys = diffContacts.map((contact) => {
      const entriesWithTranslatedKeys = Object
        .entries(contact)
        .map(([key, value]) => [this.$t(key).toString(), value]);

      return Object.fromEntries(entriesWithTranslatedKeys);
    });

    return contactsWithTranslatedKeys;
  }

  onClickEditButton() {
    this.editing = true;
  }

  async cancelEdit() {
    this.editing = false;
    this.anyFieldEdited = false;
    this.fieldComponents = await this.componentFactory.createComponentsFromFields(this.fields, this.supplierData);
  }

  onEditField() {
    this.anyFieldEdited = true;
  }
}
